// extracted by mini-css-extract-plugin
export default {"container":"Paginator_container__A82hH","item":"Paginator_item__zTFPi","active":"Paginator_active__Gvycn","inactive":"Paginator_inactive__xVOu9"};